import { CoverPhotoPanelProps } from '../../TrainerBio.d'
import styles from './CoverPhotoPanel.module.scss'

const CoverPhotoPanel = ({
  headerPhoto = '',
  ...props
}: CoverPhotoPanelProps) => {
  const style = {
    '--header-photo-url': `url(${headerPhoto})`,
  } as React.CSSProperties

  const hasCoverPhoto = !!headerPhoto

  return hasCoverPhoto ? (
    <div className={styles.coverPhoto} style={style} {...props} />
  ) : (
    <div className={styles.placeholder} {...props} />
  )
}

export default CoverPhotoPanel
